/**
 * AdminNotFound (STORY-008-006). In-shell 404 (rendered inside AdminLayout's
 * <Outlet>, so no full-viewport chrome). Catches /admin/* routes whose screen
 * story hasn't landed yet (see plan R7). --g-* tokens.
 */
import { type ReactElement } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { ADMIN_NS, registerAdminI18n } from "@/features/admin/api";

export function AdminNotFound(): ReactElement {
  registerAdminI18n();
  const { t } = useTranslation(ADMIN_NS);
  return (
    <div data-testid="admin-not-found" className="mx-auto flex max-w-md flex-col items-center gap-4 py-16 text-center">
      <p aria-hidden className="font-display text-5xl font-bold text-[var(--g-primary)]">404</p>
      <h1 className="text-lg font-semibold text-foreground">{t("notFound.title")}</h1>
      <p className="text-sm text-[var(--g-secondary)]">{t("notFound.description")}</p>
      <Link
        to="/admin"
        data-testid="admin-not-found-home"
        className="inline-flex min-h-[44px] items-center rounded-[var(--g-radius)] bg-[var(--g-primary)] px-5 text-sm font-medium text-[var(--g-on-primary)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--g-primary)]"
      >
        {t("notFound.back")}
      </Link>
    </div>
  );
}

export default AdminNotFound;
